var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isClientSet)?_c('escolher-cliente',{attrs:{"title":"Venda","show-consult-suggestion":""}}):_c('sale-wizard')}
var staticRenderFns = []

export { render, staticRenderFns }